import React from "react";

import { Wrapper } from "../../components/wrapper";
import { Header } from "../../header";
import { Footer } from "../../components/footer";
import { Page } from "./page";
import SnowEffect from "../../components/SnowEffect";

export const MainPage = () => {
  return (
    <Wrapper>
      <Header
      page="main"
      fixed={false}
      transparent={true} />

      {/* <SnowEffect /> */}
      <Page />

      <Footer />
    </Wrapper>
  );
};
